export default "__VITE_ASSET__D4b3PPOG__"